const ALL_LANGS = [
  {
    value: "en",
    label: "English",
  },
  {
    value: "de",
    label: "German",
  },
  {
    value: "fr",
    label: "French",
  },
];

/**
 * Returns a filtered + ordered list of languages for a given feature.
 * Only languages present in ALL_LANGS are included (unknown codes are ignored).
 *
 * @param {string[]} codes - e.g. ["en", "fr"]
 * @returns {{ value: string, label: string }[]}
 */
const getLangs = (codes) =>
  codes
    .map((code) => ALL_LANGS.find((l) => l.value === code))
    .filter(Boolean);

const getEnabledLangs = () => {
  const LANG_CODES = process.env.REACT_APP_LANGS?.split(",") || ["en"];
  const LANGS = getLangs(LANG_CODES);

  return LANGS.length > 0 ? LANGS : getLangs(["en"]);
};

export { ALL_LANGS, getLangs, getEnabledLangs };
